<template>
  <v-layout flat class="white shadow pa-3" fill-height row wrap>
    <form-dialog v-model="dialog" v-if="dialog" :title="title" @input="reset">
      <v-sheet class="py-2 px-4">
        <v-text-field
          :label="$t('name')"
          v-validate="'required'"
          data-vv-name="program_area"
          v-model="program_area.name"
          :data-vv-as="$t('program_area')"
          :error-messages="errors.collect('program_area')"
        />
        <div class="my-2 di-flex justify-end">
          <v-btn
            color="btn_color secondary"
            :loading="loading"
            @click="saveProgramArea"
            >{{ $t("save") }}</v-btn
          >
        </div>
      </v-sheet>
    </form-dialog>

    <v-flex xs12 md6 class="px-3">
      <v-text-field
        label="CSO Name *"
        data-vv-name="name"
        v-model="value.name"
        v-validate="'required'"
        :data-vv-as="$t('name')"
        :error-messages="errors.collect('name')"
      />
      <v-autocomplete
        item-value="id"
        :items="models"
        item-text="name"
        v-validate="'required'"
        v-model="value.cso_model_id"
        data-vv-name="organization_size"
        :data-vv-as="$t('organization_size')"
        :label="`${$t('organization_size')} *`"
        :error-messages="errors.collect('organization_size')"
      />

      <v-textarea
        rows="1"
        auto-grow
        auto-height
        :label="$t('registration_date')"
        v-model="value.registration_date"
      />
      <v-autocomplete
        multiple
        small-chips
        return-object
        item-text="name"
        item-value="id"
        :items="programs"
        v-validate="'required'"
        data-vv-name="program_areas"
        append-icon="mdi-plus-circle"
        v-model="value.program_areas"
        :data-vv-as="$t('program_areas')"
        :label="`${$t('program_areas')} *`"
        @click:append="proggamAreaClicked('program')"
        :error-messages="errors.collect('program_areas')"
      />
      <v-autocomplete
        multiple
        small-chips
        return-object
        item-value="id"
        item-text="name"
        :items="provinces"
        v-validate="'required'"
        append-icon="mdi-plus-circle"
        data-vv-name="operational_areas"
        v-model="value.operational_areas"
        :data-vv-as="$t('operational_areas')"
        :label="`${$t('operational_areas')} *`"
        @click:append="proggamAreaClicked('province')"
        :error-messages="errors.collect('operational_areas')"
      />
      <date :label="$t('assessment_date')" v-model="value.assessment_date" />
      <v-text-field
        :label="$t('registered_office')"
        v-model="value.registered_office"
      />
    </v-flex>
    <v-flex xs12 md6 class="px-3">
      <v-text-field
        data-vv-name="email"
        v-model="value.email"
        v-validate="'required'"
        :data-vv-as="$t('email')"
        :label="`${$t('email')} *`"
        :error-messages="errors.collect('email')"
      />
      <v-text-field
        v-model="value.phone"
        data-vv-name="phone"
        v-validate="'required'"
        :data-vv-as="$t('phone')"
        :label="`${$t('phone')} *`"
        :error-messages="errors.collect('phone')"
      />
      <v-text-field :label="$t('website')" v-model="value.website" />
      <v-text-field
        :label="$t('board_of_directors')"
        v-model="value.board_of_directors"
      />
      <v-text-field
        :label="`${$t('president')} *`"
        v-validate="'required'"
        data-vv-name="president"
        v-model="value.president"
        :data-vv-as="`${$t('president')} *`"
        :error-messages="errors.collect('president')"
      />
      <v-text-field :label="$t('staff_size')" v-model="value.staff_size" />
      <v-text-field :label="$t('paid_fee')" v-model="value.paid_fee" />
      <v-text-field
        :label="$t('assessment_funded_by')"
        v-model="value.assessment_funded_by"
      />
    </v-flex>

    <v-flex xs12 row wrap px-0 mt-4 class="di-flex justify-end">
      <v-btn flat @click="$router.go(-1)">Discard</v-btn>
      <v-btn
        class="mr-0"
        color="primary"
        :loading="loading"
        @click="validateForm"
        v-if="can('edit_CSOs')"
        >{{ isEditing ? "Save" : "start" }}</v-btn
      >
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ["value"],
  name: "profile",
  data() {
    return {
      tab: null,
      title: "",
      items: [],
      models: [],
      dialog: false,
      loading: false,
      program_area: {}
    };
  },
  computed: {
    isEditing() {
      return !!this.$route.params.id;
    },
    provinces: vm => vm.items.filter(x => x.type == "province"),
    programs: vm => vm.items.filter(x => x.type == "program")
  },
  methods: {
    reset() {
      this.dialog = false;
      this.loading = false;
      this.program_area = {};
    },

    proggamAreaClicked(type) {
      this.program_area = { name: "", type };
      this.title = `New ${this.$t(type)}`;
      this.dialog = true;
    },

    saveProgramArea() {
      this.loading = true;
      this.axios
        .post("program-areas", this.program_area)
        .then(res => {
          this.items.push(res.data.data);
          this.reset();
        })
        .catch(() => (this.loading = false));
    },

    validateForm() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) this.save();
        else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    },

    save() {
      this.loading = true;
      let data = Object.assign({}, this.value);
      this.axios
        .post("/CSOs", data)
        .then(res => {
          this.value.id = res.data.data.id;
          this.loading = false;
          this.$emit("saved");
        })
        .catch(() => (this.loading = false));
    }
  },

  created() {
    this.axios.get("CSO-models").then(res => {
      this.models = res.data.data;
    });
    this.axios.get("program-areas").then(res => {
      this.items = res.data.data;
    });
  },

  watch: {
    value: {
      handler() {
        this.$emit("input", this.value);
      },
      deep: true
    }
  }
};
</script>
